<template>
  <ul class="w-full">
    <li class="flex w-full items-center justify-between">
      {{ $t('components.settings.general.theme') }}
      {{ isDark }}
      <PrimeButton
        :icon="isDark ? 'pi pi-moon' : 'pi pi-sun'"
        :label="isDark ? $t('components.settings.general.dark') : $t('components.settings.general.light')"
        @click="toggleDarkMode()"
      />
    </li>
  </ul>
</template>

<script>
export default defineNuxtComponent({
  computed: {
    isDark() {
      return document.documentElement.classList.contains('dark');
    },
  },
  methods: {
    toggleDarkMode() {
      document.documentElement.classList.toggle('dark');
    },
  },
});
</script>

<style  scoped></style>
